import { PrismicService } from '../../services/prismic/prismic.service';
import {PrismicHomePage} from "../../../types/app-types";

export class HomeContent {
  cta: CTA;
  ctas: CTA[];
  landschap: Landschap;
  lanes: Lane[];
  subTitle: string;
  title: string;

  constructor(
    private prismic: PrismicService,
    private doc: PrismicHomePage
  ) {
    //There should be only one home-page document per tag, if more get first
    this.title = prismic.convertToText(doc.title);
    this.cta = <CTA>{
      active: doc.cta_active,
      title: prismic.convertToText(doc.cta_title),
      subtitle: prismic.convertToText(doc.cta_subtitle),
      backgroundImage: <Image>{
        url: doc.cta_background_image?.url,
        alt: doc.cta_background_image?.alt
      }
    };
    this.ctas = [];
    this.lanes = [];

    //Landschap
    doc.body.forEach(slice => {
      if (slice.slice_type === 'landschap') {
        this.landschap = {
          active: slice.primary.landschap_active,
          title: prismic.convertToText(slice.primary.landschap_title),
          subtitle: prismic.convertToHtml(slice.primary.landschap_subtitle)
        };
      }
    });

    //CTA's
    doc.body1.forEach(slice => {
      if (slice.slice_type === 'cta_s') {
        slice.items.forEach(cta => {
          this.ctas.push(
            <CTA>{
              active: cta.cta_active,
              icon: cta.cta_icon,
              title: prismic.convertToText(cta.cta_title),
              subtitle: prismic.convertToText(cta.cta_subtitle),
              color: cta.cta_color,
              class: cta.cta_class,
              link: cta.cta_link,
              external: cta.cta_external_link
            });
        });
      }
    });

    //Testimonials's
    const lanes: Lane[] = [];
    let lane = <Lane>{ items: [] };
    doc.body2.forEach(slice => {
      switch (slice.slice_type) {
        case 'testimonial': {
          const testimonial = new Testimonial();
          testimonial.active = slice.primary.testimonial_active;
          testimonial.orientation = slice.primary.testimonial_orientation;
          testimonial.width = slice.primary.testimonial_width;
          testimonial.title = prismic.convertToText(slice.primary.testimonial_title);
          testimonial.text = prismic.convertToHtml(slice.primary.testimonial_text);
          testimonial.image = <Image>{
            url: slice.primary.testimonial_image?.url,
            alt: slice.primary.testimonial_image?.alt
          };
          testimonial.button = slice.primary.testimonial_button;
          testimonial.link = slice.primary.testimonial_link;

          //Add new lane if width = 100%
          if (testimonial.width === '100%') {
            if (lane.items.length > 0) {
              lanes.push(lane);
              lane = <Lane>{ items: [] };
            }
            lanes.push({ items: [testimonial] }); // Push new 100% lane
          } else {
            lane.items.push(testimonial);
          }
          break;
        }
        case 'two_column_text': {
          // Always 100%
          if (lane.items.length > 0) {
            lanes.push(lane); //push current lane
            lane = <Lane>{ items: [] }; //create new lane
          }
          const twoColumn = new TwoColumn();
          twoColumn.active = slice.primary.block_active;
          twoColumn.title = prismic.convertToText(slice.primary.block_title);
          twoColumn.leftText = prismic.convertToHtml(slice.primary.left_column);
          twoColumn.rightText = prismic.convertToHtml(slice.primary.right_column);
          twoColumn.link = slice.primary.block_link;

          lanes.push(<Lane>{ items: [twoColumn] });
          break;
        }
        case 'account': {
          const account = new Account();
          account.active = slice.primary.account_active;
          account.width = slice.primary.account_width;
          account.titleLoggedIn = prismic.convertToText(slice.primary.account_title_loggedin);
          account.titleNotLoggedIn = prismic.convertToText(slice.primary.account_title_not_loggedin);
          account.benefitsLoggedIn = prismic.convertToHtml(slice.primary.account_benefits_loggedin);
          account.benefitsNotLoggedIn = prismic.convertToHtml(slice.primary.account_benefits);
          account.buttonNotLoggedIn = slice.primary.account_button;
          account.buttonLoggedIn = slice.primary.account_button_loggedin;

          //Add new lane if width = 100%
          if (account.width === '100%') {
            if (lane.items.length > 0) {
              lanes.push(lane);
              lane = <Lane>{ items: [] };
            }
            lanes.push(<Lane>{ items: [account] }); // Push new 100% lane
          } else {
            lane.items.push(account);
          }
          break;
        }
      }
    });

    if (lane.items.length > 0) {
      lanes.push(lane);
    }

    this.lanes.push(...lanes);
  }
}

export class Lane {
  items: any[];

}

export class CTA {
  active: boolean;
  class: string;
  color: string;
  icon: string;
  link: string;
  external: boolean;
  subtitle: string;
  title: string;
  type: 'CTA';
  backgroundImage: Image;
}

export class Testimonial {
  type = 'Testimonial';
  active: boolean;
  orientation: string;
  width: string;
  title: string;
  text: string;
  image: Image;
  button: string;
  link: string;
}

export class Account {
  type = 'Account';
  active: boolean;
  width: string;
  titleLoggedIn: string;
  titleNotLoggedIn: string;
  benefitsLoggedIn: string;
  benefitsNotLoggedIn: string;
  buttonLoggedIn: string;
  buttonNotLoggedIn: string;
}

export class TwoColumn {
  type = 'TwoColumn';
  active: boolean;
  title: string;
  leftText: string;
  rightText: string;
  link: string;
}

export class Image {
  url: string;
  alt: string;
}

export class Landschap {
  active: boolean;
  title: string;
  subtitle: string;
}
